import { BoxStyleOptions } from '@/components/layout/types';
import { getSpacing } from '@/theme/spacing';
import type { ViewStyle } from 'react-native';

export function buildBoxStyle(options: BoxStyleOptions): ViewStyle {
  const {
    padding,
    paddingX,
    paddingY,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    margin,
    marginX,
    marginY,
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
    gap,
    gapX,
    gapY,
    flex,
    flexGrow,
    flexShrink,
    flexBasis,
    borderRadius,
    borderTopLeftRadius,
    borderTopRightRadius,
    borderBottomLeftRadius,
    borderBottomRightRadius,
    borderWidth,
    borderColor,
    backgroundColor,
    width,
    height,
    minWidth,
    minHeight,
    maxWidth,
    maxHeight,
    overflow,
    position,
    zIndex,
    bottom,
    left,
    right,
    top,
  } = options;

  const style: ViewStyle = {};

  // Apply from general -> axis -> side to keep expected override precedence.
  if (padding !== undefined) style.padding = getSpacing(padding);
  if (paddingX !== undefined) style.paddingHorizontal = getSpacing(paddingX);
  if (paddingY !== undefined) style.paddingVertical = getSpacing(paddingY);
  if (paddingTop !== undefined) style.paddingTop = getSpacing(paddingTop);
  if (paddingBottom !== undefined) style.paddingBottom = getSpacing(paddingBottom);
  if (paddingLeft !== undefined) style.paddingLeft = getSpacing(paddingLeft);
  if (paddingRight !== undefined) style.paddingRight = getSpacing(paddingRight);

  if (margin !== undefined) style.margin = getSpacing(margin);
  if (marginX !== undefined) style.marginHorizontal = getSpacing(marginX);
  if (marginY !== undefined) style.marginVertical = getSpacing(marginY);
  if (marginTop !== undefined) style.marginTop = getSpacing(marginTop);
  if (marginBottom !== undefined) style.marginBottom = getSpacing(marginBottom);
  if (marginLeft !== undefined) style.marginLeft = getSpacing(marginLeft);
  if (marginRight !== undefined) style.marginRight = getSpacing(marginRight);

  if (gap !== undefined) style.gap = getSpacing(gap);
  if (gapX !== undefined) style.columnGap = getSpacing(gapX);
  if (gapY !== undefined) style.rowGap = getSpacing(gapY);

  if (flex !== undefined) style.flex = flex;
  if (flexGrow !== undefined) style.flexGrow = flexGrow;
  if (flexShrink !== undefined) style.flexShrink = flexShrink;
  if (flexBasis !== undefined) style.flexBasis = flexBasis;

  if (borderRadius !== undefined) style.borderRadius = getSpacing(borderRadius);
  if (borderWidth !== undefined) style.borderWidth = getSpacing(borderWidth);
  if (borderColor !== undefined) style.borderColor = borderColor;
  if (backgroundColor !== undefined) style.backgroundColor = backgroundColor;

  if (width !== undefined) style.width = width;
  if (height !== undefined) style.height = height;
  if (minWidth !== undefined) style.minWidth = minWidth;
  if (minHeight !== undefined) style.minHeight = minHeight;
  if (maxWidth !== undefined) style.maxWidth = maxWidth;
  if (maxHeight !== undefined) style.maxHeight = maxHeight;

  if (overflow !== undefined) style.overflow = overflow;

  if (position !== undefined) style.position = position;
  if (zIndex !== undefined) style.zIndex = zIndex;

  if (bottom !== undefined) style.bottom = getSpacing(bottom);
  if (left !== undefined) style.left = getSpacing(left);
  if (right !== undefined) style.right = getSpacing(right);
  if (top !== undefined) style.top = getSpacing(top);

  if (borderTopLeftRadius !== undefined)
    style.borderTopLeftRadius = getSpacing(borderTopLeftRadius);
  if (borderTopRightRadius !== undefined)
    style.borderTopRightRadius = getSpacing(borderTopRightRadius);
  if (borderBottomLeftRadius !== undefined)
    style.borderBottomLeftRadius = getSpacing(borderBottomLeftRadius);
  if (borderBottomRightRadius !== undefined)
    style.borderBottomRightRadius = getSpacing(borderBottomRightRadius);

  return style;
}
